export const LOCAL = "http://localhost:8080/";
export const DEVELOPMENT = "tirefinderreact-dev.apps.pcfepgw.gm.com";
export const TEST = "tirefinderreact-test.apps.pcfepgw.gm.com";
export const QA = "tirefinderreact-qa.apps.pcfepgw.gm.com";
export const OSS_PROD = "//oss.gm.com/oss/o/d/US/";
export const OSS_PP = "//oss.pp.gm.com/oss/o/d/US/";
export const OSS_test = "//oss-test.cp-epg3i.gm.com/oss/o/d/US/";
export const API_BASE_PATH = 'api/v1/';
export const API_TIRE_SIZE_PATH = 'tireSize/ymm/';
export const DEALER_API = 'dealer/';
export const dealerGeoSearch = 'info/{latitude}/{longitude}/{range}/{brand}';
export const dealerSearchName = 'name/{dealerName}/{brand}';
export const dealerSearchBac = 'bac/{bac}';
export const dealerServices = 'BAC/{bac}/year/{year}/make/{make}/model/{model}/tiresize/{tiresize}/innetwork/{innetwork}'
